import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=c87f2faa&scoped=true"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=c87f2faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87f2faa",
  null
  
)

export default component.exports